import { formatTimestamp } from '../lib/format.js';
import type { AuditEvent } from '../lib/api.js';

export interface AuditTableProps {
  readonly events: readonly AuditEvent[];
  readonly onRefresh?: () => void;
}

export function AuditTable({ events, onRefresh }: AuditTableProps) {
  return (
    <div className="card" aria-label="audit-table">
      <div className="row" style={{ marginBottom: 8 }}>
        <h2 style={{ margin: 0 }}>Audit Log</h2>
        {onRefresh ? (
          <button className="btn secondary" onClick={onRefresh}>↻</button>
        ) : null}
      </div>
      {events.length === 0 ? (
        <div className="muted" style={{ fontSize: 13 }}>Henüz kayıt yok.</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Zaman</th>
              <th>Aktör</th>
              <th>Aksiyon</th>
              <th>Hedef</th>
            </tr>
          </thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.eventId}>
                <td className="mono">{formatTimestamp(e.createdAt)}</td>
                <td>
                  <span className="muted">{e.actorType}</span>{' '}
                  {e.actorId ? <span className="mono">{e.actorId}</span> : null}
                </td>
                <td>
                  <span className="pill ok">{e.action}</span>
                </td>
                <td className="mono">{e.targetType}/{e.targetId ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
